(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/result.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/result.js');

'use strict';

const {
  useEffect
} = React;
const {
  useAtomValue
} = jotai;
const {
  selectedResultAtom,
  correctionStepAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
const {
  ResultStart,
  ButtonPlay
} = svs.lyckoplatsen.components.page_result.react.components;
const {
  ProgressBarContainer,
  ResultDraw,
  ResultDetails
} = svs.lyckoplatsen.components.shared_result.react.components;
const {
  CharityPayout
} = svs.lyckoplatsen.components.shared_charity_payout.react.components;
const {
  WidgetArea
} = svs.components.tb_ui_react.widget_area;
const Result = () => {
  const correctionStep = useAtomValue(correctionStepAtom);
  const selectedResult = useAtomValue(selectedResultAtom);
  useEffect(() => {
    if (correctionStep >= 1 && correctionStep <= 3) {
      svs.lyckoplatsen.utils.ui.hideFooter();
    }
    return () => {
      svs.lyckoplatsen.utils.ui.showFooter();
    };
  }, [correctionStep]);
  if (correctionStep === 0) {
    return React.createElement("div", {
      className: "lp-page-result"
    }, React.createElement(ResultStart, null));
  }
  return React.createElement("div", {
    className: "lp-result lp-grow"
  }, React.createElement(ProgressBarContainer, {
    isResult: true
  }), correctionStep >= 1 && correctionStep <= 3 && React.createElement(ResultDraw, null), correctionStep === 4 && React.createElement(React.Fragment, null, React.createElement(ResultDetails, {
    result: selectedResult
  }), React.createElement(ButtonPlay, null), productMapping.isLyckoplatsenPrimary(selectedResult.productId) && React.createElement(CharityPayout, null), React.createElement(WidgetArea, {
    className: "lp-result-widget-area",
    areaName: "resultWidgetArea",
    widgetArea: "resultWidgetArea"
  })));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  Result
});

 })(window);